export const TelefonoRegex = RegExp(/^[0-9]{0,9}$/)
export const CelularRegex = RegExp(/^(\+[0-9]{2}\s)?[0-9]{3}[\s\-]?[0-9]{3}\s?[0-9]{3,4}$/)
export const CorreoRegex = RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/)
